import React from 'react';
import "./Footer.scss"
import logoSvg from "../assets/images/logos/logo_only_secondary.svg"

import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import GoogleMapComponent from "./GoogleMapComponent";

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

const Footer = () => {
    return (
        <div className={"footer-container"}>
            <img alt="" src={logoSvg} className={"footer-svg"}/>
            <div className="footer-card container-fluid">

                <div className="row g-4">
                    <div className="col-12">
                        <div className="d-flex flex-lg-row flex-column align-items-start">
                            <div className="flex-grow-1 footer-map-container">

                                <div className="footer-map">
                                    <GoogleMapComponent />
                                </div>
                            </div>

                            {/* Contact Info Section */}
                            <div className="contact-info ms-lg-4 mt-4 mt-lg-0" style={{textAlign: 'start'}}>
                                <div className="row g-3">
                                    <div className="col-lg-6 col-md-6 col-12 f-12">
                                        <h6>ADDRESS</h6>
                                        <p style={{paddingBottom: 0}}>111 28 Ave NW, Calgary, AB T2M 2K3</p>
                                        <h6>BUSINESS HOURS</h6>
                                        <p style={{paddingBottom: 0}}>Mon - Fri 9:00 am - 4:30 pm<br/>Sat - Sun Closed</p>
                                    </div>
                                    <div className="col-lg-6 col-md-6 col-12 f-12">
                                        <h6>CONTACT</h6>
                                        <p style={{paddingBottom: 0}}>
                                            OFFICE <a className="contact-detail-link" href="tel:+14039307788">(403) 930-7788</a><br/>
                                            FAX (403) 930-7780<br/>
                                            EMAIL <a className="contact-detail-link" href="mailto:reception@arkhamlaw.com">reception@arkhamlaw.com</a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/*<div className="footer-border"></div>*/}
            <div className="copyright">
                © 2026 Arkham Law
            </div>
        </div>
    );
};

export default Footer;
